import { useState } from "react";

function useDynamicInput(props) {
  const listYetRegistred = props.map((item) => item.type_triathlon);
  const [fields, setFields] = useState(listYetRegistred);

  const handleCheckboxChange = (e) => {
    const checkboxValue = e.target.value;
    if (e.target.checked) {
      setFields([...fields, checkboxValue]);
    } else {
      setFields(fields.filter((field) => field !== checkboxValue));
    }
  };
  // console.log("fields from useDynamic", fields);
  return { fields, handleCheckboxChange };
}

export default useDynamicInput;
